/**
 * @file   公共面包屑
 * @create macaiqi 2021/07/27
 * @update
 */
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./index.scss";

const Bread = (props) => {
  const { path, title, secondtitle } = props;
  const navigate = useNavigate();
  return (
    <div className="bread">
      <div className="l">
        <Link to="/DigitalResourceLibrary/Home" className="tohome itemlink">
          <i className="iconfont icon-shouyetianchong" />
          <span>首页</span>
        </Link>
        {path ? (
          <Link to={path} className="itemlink">
            <span>{title}</span>
          </Link>
        ) : (
          <div className="itemlink">
            <span>{title}</span>
          </div>
        )}
        {secondtitle && (
          <div className="itemlink">
            <span>{secondtitle}</span>
          </div>
        )}
      </div>

      <div className="back" onClick={() => navigate(-1)}>
        返回
      </div>
    </div>
  );
};

export default Bread;
